const baseData = {
  terminalmanage: {
    terminalInfo: {
      terminalNumber: "หมายเลข S/N",
      terminalBarcode: "รหัส OBD",
      Version: "เฟิร์มแวร์",
      SIMCardNumber: "SIM card number",
      founder: "ผู้สร้าง",
      creationTime: "วันที่สร้าง",
      seeHistory: "ดูประวัติ",
      wakeUpTimeInterval: "หยุดทำงาน (นาที)",
      unusualAlarmingValue: "ค่าแจ้งเตือนที่ผิดปกติ",
      IOstate: "สถานะ MCB",
      wakeUpTimeKeepDuration: "ทำงาน (นาที)",
      abnormalAlarmOff: "Abnormal alarm off",
      ChangeAlarm: "Change alarm",
      turnOff: "Turn off timed wake-up",
      trunOn: "Enable timed wake up",
      bindingState: "Binding state",
      binding: "Binding",
      unbind: "Unbind",
      authorize: "Authorized to",
      searchWidth: {
        width1: "80px",
        width2: "90px",
        width3: "110px",
        width4: "50px"
      },
      tableWidth: "145",
      message: {
        noImportInfo: "ไม่มีข้อมูลความล้มเหลวในการนำเข้า",
        selectSIM: "โปรดเลือกซิมการ์ดที่จะส่งออก"
      },
      createAndUpdate: {
        create: "เพิ่ม OBD ใหม่",
        update: "แก้ไข OBD",
        error: {
          noSIM: "Please select sim card",
          noTerminal: "กรุณาป้อน Terminal Serial No.",
          terminalType: "คุณสามารถป้อนตัวเลขแปดหลักเท่านั้น และไม่ได้ขึ้นต้นด้วยเลข 0",
          noTerminalBarcode: "โปรดป้อนรหัส OBD",
          terminalBarcodeType: "เริ่มต้นด้วย V2A และเพิ่ม 5-7 ตัวอักษรหรือตัวเลขรวม 8-10 หลัก",
          noOBDcode: "Please enter the OBD code",
          OBDcodeType: "You can only type 30 characters of A027E00428",
          noExpritTime: "โปรดเลือกเวลาหมดอายุ"
        },
        labelWidth: "100px"
      }
    },
    SIM: {
      SIMCardNumber: "SIM card number",
      CarrierType: "Carrier type",
      searchWidth: {
        width1: "120px",
        width2: "70px"
      },
      message: "No sim card information failed to import",
      operator: "Operator",
      createAndUpdate: {
        create: "Create",
        update: "Update",
        message: {
          noSim: "Please enter the sim card number",
          simTypeError: "The mobile sim card number is 11 digits",
          unicomError: "Unicom sim card number 20 - digit letters and Numbers",
          selectOperator: "Please select the operator",
          noIccid: "Please enter the ICCID",
          iccidTypeError: "ICCID is 20-bit letters and Numbers"
        },
        labelWidth: "120px"
      }
    },
    terminalchange: {
      terminalNumber: "Terminal number",
      searchWidth: {
        width1: "40px",
        width2: "110px",
        width3: "45px",
        width4: "110px"
      },
      binding: "Binding",
      unbind: "Unbind",
      SIMCardNumber: "SIM card number",
      bindingState: "Binding state",
      founder: "Founder",
      unbundlingPeople: "Unbundling people",
      reason: "Replace the reason",
      tableWidth: {
        terminalNumber: "150",
        bindingState: "130",
        unbundlingPeople: "180"
      },
      msg1: "Please select OBD device number",
      msg2: "Please input the reason for the change"
    }
  },
  configResponse:{
    configName:"ชื่อโปรไฟล์",
    responseType:"ประเภทการตั้งค่า",
    responseInit:"อุปกรณ์เริ่มต้น",
    responsePacketCount:"จำนวนรถวิ่งบรรจุภัณฑ์ข้อมูล",
    responseDistance:"ข้อมูลการดำเนินงานช่วงของยานพาหนะ",
    responseHeadErrCode:"ระบุสาเหตุของข้อผิดพลาด",
    responseFlameoutVoltage:"ค่าอ้างอิงของแรงดันไฟฟ้าลดลง(0.1โวลต์)",
    responseVersion:"หมายเลขรุ่นซอฟต์แวร์",
    responseFlameoutWait:"เวลารอหลังจากถ่วงเวลา",
    responseDataMode:"โหมดการเก็บข้อมูล",
    responseUpgradeAddress:"ที่อยู่การอัพเกรดซอฟต์แวร์",
    responseHeadErrMsg:"รายละเอียดของสาเหตุของข้อผิดพลาด",
    responseBusinessAddress:"ที่อยู่เซิร์ฟเวอร์ธุรกิจ",
    responseLinkHeartbeat:"การเชื่อมโยงการเต้นของหัวใจ(วินาที)",
    responseSleepReportInterval:"รายงานช่วงเวลาปกติหลังจากการพักตัว(นาที)",
    responseHeadCmd:"การตอบสนองคำสั่ง",
    responseInterval:"ช่วงเวลาการเก็บรวบรวมข้อมูลสำหรับยานพาหนะ(วินาที)",
    responseSleepVoltageInterval:"ช่วงหลังการพักตัวของแรงดันไฟฟ้า(0.1โวลต์)",
    responseFlameoutShutdown:"การตั้งค่าเวลาปิดหลังจากไฟดับ(นาที)",
    responseAgpsAddress:"ที่อยู่บริการ AGPS",
    createAndUpdate:{
      create: "เพิ่มการตอบสนองการตั้งค่า OBD",
      update: "แก้ไขการตอบสนองการตั้งค่า OBD",
      error: {
        noConfigName:"ป้อนชื่อโปรไฟล์"
      },
      labelWidth: "85px"
    }
  },
  terminalConfig:{    
    terminalId: "เทอร์มินัล ID",
    responseVid:"ประเภทรถ",
    responseYear:"ปี",
    responseDisplacement:"การปล่อย",
    responseInit:"อุปกรณ์เริ่มต้น",
    configName:"ชื่อโปรไฟล์",
    terminalCode:"รหัสเทอร์มินัล",
    createAndUpdate:{
      binding:"เลือกเทอร์มินัลผูกพันการตั้งค่า",
      create: "เพิ่มการตั้งค่าอุปกรณ์ 95OBD",
      update: "แก้ไขการตั้งค่าอุปกรณ์ 95OBD"
    }
  }
} 
export default baseData